import React from 'react';
import iconMap from '../iconMap';
import { bottomNavConfig } from '../appConfig';

function BottomNav({ app }) {
  const currentScene = app.getCurrentScene();

  return (
    <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-r from-gray-900/90 to-gray-800/90 backdrop-blur-sm border-t border-gray-700/50">
      <div className="flex justify-around items-center h-full px-4">
        {bottomNavConfig.screens.map(screen => {
          const Icon = iconMap[screen.id];
          return (
            <button 
              key={screen.id}
              onClick={() => app[screen.action]()}
              className={`
                flex flex-col items-center gap-1
                ${screen.isMain ? 'transform -translate-y-4 bg-gray-900 p-4 rounded-full border border-blue-500/30 shadow-lg' : ''}
                ${currentScene === screen.id ? 
                  screen.isMain ? 'text-blue-400 shadow-blue-500/50' : 'text-blue-400' 
                  : 'text-gray-400 opacity-50'}
                ${screen.isMain && currentScene !== screen.id ? 'shadow-blue-500/20' : ''}
              `}
            >
              <Icon size={24} />
              <span className="text-xs">{screen.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default BottomNav;
